import React from "react";
import classNames from "classnames";
import Market from "../Market/Market";
import Icon from "../../Icon/Icon";
import plusIcon from "icons/plus-white.svg";
import minusIcon from "icons/minus-white.svg";
import lockCloseIcon from "icons/lock-close.svg";


export default class MarketTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.tableType = this.getType();
  }

  getType() {
    const { title } = this.props;
    let type = "default";
    if (title.includes("HANDICAP")) {
      type = "handicap";
    }
    if (title.includes("TOTAL")) {
      type = "total";
    }

    return type;
  }

  renderSubtitles() {
    const { data } = this.props;

    return (
      <div className="market-table__row">
        { data.td.map((subtitle, i) => (
          <div className="market-table__col" key={ i }>
            <span className="market-table__subtitle">{ subtitle }</span>
          </div>
        )) }
      </div>
    );
  }

  renderMarkets() {
    const { data } = this.props;

    let renderer;
    switch (this.tableType) {
      case "total":
        renderer = this.renderTotal;
        break;
      case "handicap":
        renderer = this.renderHandicap;
        break;
      default:
        renderer = this.renderDefault;
    }

    return data.markets.map(marketId => (
      <Market marketId={ marketId } renderAnyway={ true } key={ marketId }>
        { ({ outcomes }) => {
          if (!outcomes) return null;

          const blocked = outcomes.filter(o => !o.status).length > 0;
          return (
            <div className={ classNames("market-table__row", { blocked }) }>
              { renderer.call(this, outcomes, blocked) }
              { blocked && <Icon glyph={ lockCloseIcon }/> }
            </div>
          );
        } }
      </Market>
    ));
  }

  renderHandicap(outcomes, blocked) {
    return outcomes.map(bet => (
      <React.Fragment key={ bet["bet_id"] }>
        <div className="market-table__col">
          { bet["name"] }
        </div>
        <div
          className={ classNames("market-table__col", "market-table__bet", { selected: bet.selected }) }
          onClick={ !blocked ? bet.toggleBet : undefined }
          key={ bet["bet_id"] }
        >
          <div className="market-table__cf">{ bet["cf"] }</div>
          { !blocked && (
            <div className="market-table__button">
              <Icon glyph={ bet.selected ? minusIcon : plusIcon }/>
            </div>
          ) }
        </div>
      </React.Fragment>
    ));
  }
  renderTotal(outcomes, blocked) {
    return outcomes.map(bet => (
      <React.Fragment key={ bet["bet_id"] }>
        <div className="market-table__col">
          { bet["name"] }
        </div>
        <div
          className={ classNames("market-table__col", "market-table__bet", { selected: bet.selected }) }
          onClick={ !blocked ? bet.toggleBet : undefined }
          key={ bet["bet_id"] }
        >
          <div className="market-table__cf">{ bet["cf"] }</div>
          { !blocked && (
            <div className="market-table__button">
              <Icon glyph={ bet.selected ? minusIcon : plusIcon }/>
            </div>
          ) }
        </div>
      </React.Fragment>
    ));
  }



  renderDefault(outcomes, blocked) {
    return outcomes.map(bet => (
      <div
        className={ classNames("market-table__col", "market-table__bet", { selected: bet.selected }) }
        onClick={ !blocked ? bet.toggleBet : undefined }
        key={ bet["bet_id"] }
      >
        <div className="market-table__cf">{ bet["cf"] }</div>
        { !blocked && (
          <div className="market-table__button">
            <Icon glyph={ bet.selected ? minusIcon : plusIcon }/>
          </div>
        ) }
      </div>
    ));
  }

  render() {

    const { title } = this.props;

    return (
      <div className={ `market-table market-table--${this.tableType}` }>
        <div className="market-table__row">
          <div className="market-table__col">
            <span className="market-table__title">{ title }</span>
          </div>
        </div>
        { this.renderSubtitles() }
        { this.renderMarkets() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EsportsGame/MarketTable/MarketTable.jsx